import React from 'react';
import { IconButton } from '@material-ui/core';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';

const PointsArrow = ({ valueState, setState, field }) => {
    const onClickUp = () => {
        if (valueState[field] >= valueState[field + '_max'])
            return
        setState({ ...valueState, [field]: valueState[field] + 1 })
    }
    const onClickDown = () => {
        if (valueState[field] <= 0)
            return
        setState({ ...valueState, [field]: valueState[field] - 1 })
    }
    return (
        <React.Fragment>
            <IconButton aria-label="delete" size="small" onClick={() => onClickUp()}>
                <ArrowUpwardIcon fontSize="inherit" />
            </IconButton>
            <IconButton aria-label="delete" size="small" onClick={() => onClickDown()}>
                <ArrowDownwardIcon fontSize="inherit" />
            </IconButton>
        </React.Fragment>
    );
}
export default PointsArrow

